module.exports = __webpack_public_path__ + "img/kp1.52hover.a059e0ef.png";